export default "__VITE_ASSET__3Y9lPbew__"